/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_View_Title_AccentInputs */

const en_platform_view_title_accent = /** @type {(inputs: Platform_View_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`what you set up.`)
};

const pl_platform_view_title_accent = /** @type {(inputs: Platform_View_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`co ustawisz.`)
};

/**
* | output |
* | --- |
* | "what you set up." |
*
* @param {Platform_View_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_view_title_accent = /** @type {((inputs?: Platform_View_Title_AccentInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_View_Title_AccentInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_view_title_accent(inputs)
	return en_platform_view_title_accent(inputs)
});